import { ColumnFiltersState } from '@tanstack/react-table';
import FilterNumberModal from 'legacy/app/components/modal/FilterNumberModal';
import { getCookie } from 'legacy/utilities/Auth';
import { useRef, useState } from 'react';
import { Form } from 'react-bootstrap';

const instanceId = getCookie('dmInstanceId');

export type TNumberFilter = {
	id: string;
	value: {
		min: string | null;
		max: string | null;
	};
};

export const InputWithNumbersFilterModal = ({
	title,
	name,
	onChange,
}: {
	title: string;
	name: string;
	onChange: (value: TNumberFilter) => void;
}) => {
	const existingFilters = localStorage.getItem(
		`${instanceId}-projects-list-filter`
	);
	const isFilterPreExisting = existingFilters
		? ((JSON.parse(existingFilters) as ColumnFiltersState).find(
				(filter) => filter.id === name
		  ) as TNumberFilter)
		: null;
	const inputRef = useRef<HTMLInputElement>(null);
	const [showModal, setShowModal] = useState(false);
	const inputValue =
		isFilterPreExisting?.value.min || isFilterPreExisting?.value.max
			? `${isFilterPreExisting.value.min ?? ''}-${
					isFilterPreExisting.value.max ?? ''
			  }`
			: '';

	return (
		<>
			<FilterNumberModal
				defaultVal={inputValue}
				defaultTitle={title}
				show={showModal}
				toggleModal={() => {
					setShowModal(false);
					setTimeout(() => {
						inputRef.current?.blur();
					}, 170);
				}}
				updateSearch={(min: string, max: string) => {
					onChange({
						id: name,
						value: {
							min: min !== undefined ? min : null,
							max: max !== undefined ? max : null,
						},
					});
					if (inputRef.current) {
						if (min === '' && max === '') {
							inputRef.current.value = '';
							return;
						}
						inputRef.current.value = `${min}-${max}`;
					}
				}}
			/>

			<Form.Control
				ref={inputRef}
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					setShowModal(true);
				}}
				defaultValue={inputValue}
			/>
		</>
	);
};

InputWithNumbersFilterModal.displayName = 'InputWithNumbersFilterModal';
